const defaultDuration = 2000;

let nextId = 1;

// Replaces toastr. showSuccessMessage / showErrorMessage keep their old
// signatures because the page scripts and views call them directly.
export default (Alpine) => {
  Alpine.store('toasts', {
    items: [],

    push(type, message, duration) {
      const id = nextId++;
      const timeout = Number(duration) > 0 ? Number(duration) : defaultDuration;

      this.items.unshift({ id, type, message: String(message ?? ''), timeout });
      setTimeout(() => this.dismiss(id), timeout);
    },

    dismiss(id) {
      this.items = this.items.filter((toast) => toast.id !== id);
    },
  });

  window.showSuccessMessage = (message, duration) => Alpine.store('toasts').push('success', message, duration);
  window.showErrorMessage = (message, duration) => Alpine.store('toasts').push('error', message, duration);
};
